export default {
  init() {

     // JavaScript to be fired on all pages
     $('.hamburger , .hamburger-text').click(function(event) {

      event.preventDefault()


     

      if ( $(this).hasClass('is-active') ) {
        $('.hamburger').removeClass( 'is-active' );
        $('.hamburger-text').removeClass( 'is-active' );
         $('.tm-menu-container' ).slideUp('slow',function(){
           
         })

          
      } else {
        $('.hamburger').addClass( 'is-active' );
        $('.hamburger-text').addClass( 'is-active' );

        $('.tm-menu-container' ).slideDown('slow',function(){
          console.log($(this))
         
         })
           
      }



  


      


 




      //$(this).toggleClass('is-active');
     
    });
     // test
/* se vorrò abilitare swipe
const test = new Swiper('.swiper-container');
test;
*/



/*
    const test = new Swiper('.swiper-container-product',{
      slidesPerView: 'auto',
      spaceBetween: 0,
      freeMode: false,
      freeModeMomentum: true,
      freeModeMomentumRatio: 2,
      freeModeMomentumVelocityRatio: 0.5,
      freeModeSticky: true,
      loop: true,
  //    loopedSlides: 3,
      speed: 3000,
      grabCursor: true,
      autoplay: { delay: 1000 },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
    });
    test*/

    
   
  },
  finalize() {  

    $('header.banner').sticky({
      topSpacing: 0,
      zIndex: 100,
      responsiveWidth: true,
    });
    
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js